'use strict'

/**
 * Module qui gère le carrousel de réassurance mobile
 * Fait défiler verticalement les items uniquement sur appareils tactiles
 */

import responsive from 'Helpers/responsive.js'

const CONFIG = {
    ROTATION_INTERVAL: 3500,
    ANIMATION_DURATION: 850
}

class ReassuranceCarousel {
    constructor(container) {
        this.container = container
        this.track = container.querySelector('.reassurance-ambiance__track')
        this.intervalTimer = null
    }

    rotateItems() {
        const item = this.track.children[0]
        if (!item) return

        const height = item.offsetHeight

        this.track.style.transition = `transform ${CONFIG.ANIMATION_DURATION}ms ease`
        this.track.style.transform = `translateY(-${height}px)`

        this.track.addEventListener(
            'transitionend',
            () => {
                this.track.style.transition = 'none'
                this.track.appendChild(this.track.children[0])
                this.track.style.transform = 'translateY(0)'
                void this.track.offsetHeight
            },
            { once: true }
        )
    }

    start() {
        this.intervalTimer = setInterval(
            () => this.rotateItems(),
            CONFIG.ROTATION_INTERVAL
        )
    }

    stop() {
        clearInterval(this.intervalTimer)
    }
}

function init() {
    if (!responsive.isMobile()) return

    document
        .querySelectorAll('.reassurance-ambiance [data-rotate-mobile]')
        .forEach((container) => {
            const carousel = new ReassuranceCarousel(container)
            carousel.start()
        })
}

export default { init }
